import React,{useEffect,useState} from 'react';


import Select from "react-select";

import ReactDatetime from "react-datetime";

import moment from "moment";

// reactstrap components
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Table,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  UncontrolledTooltip
} from "reactstrap";

// import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';

import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { withRouter } from "react-router-dom";
import {EMAIL_TEMPLATE,DAYWISE_EMAIL_REPORTS} from "../../../constants.js";
import axios from "axios"; 

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";


const TextReports = (props) => {
  
  const [singleSelect, setsingleSelect] = useState(null);
  const [templates,setTemplates] = useState([]);
  const [daywiseList,setDaywiseList] = useState([]);
  const[search,setSearch] = useState({
    fromdate:"",
    todate:"",
    
  });
  const[validate,setValidate] = useState({
    message:"",
    notValid:false
  })

  useEffect(()=>{
    function getTemplates(){
      axios.get(EMAIL_TEMPLATE).then((res)=>{
        setTemplates(res.data.message)
      }).catch((err)=>{
        console.log("error===>",err);
      })
    }
    getTemplates();
  },[])

  const submitHandler = async() =>{
  
    let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(search.todate).format("YYYY-MM-DD");
    
    await axios.get(DAYWISE_EMAIL_REPORTS+"?startdatePickup="+fromdate+"&enddatePickup="+todate+"&templateid="+singleSelect?.value).then((res)=>{
      setDaywiseList(res.data.message)
    }).catch((err)=>console.log("error====>",err))
  
  }

  const generatePdf=async()=>{
    let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(search.todate).format("YYYY-MM-DD");
    await axios.get(DAYWISE_EMAIL_REPORTS+"?startdatePickup="+fromdate+"&enddatePickup="+todate+"&templateid="+singleSelect?.value).then((res)=>{
     const body=res.data.message.length>0?res.data.message:"No Records"
      const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
      const ws = XLSX.utils.json_to_sheet(body);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, singleSelect.value + fileExtension);
    }).catch((err)=>console.log("error====>",err))

   
  
  
      
    

  }

  function createData(sno,date,nsent,ndelivered,nread,ncost,tsent,tdelivered,tread) {
    return {sno,date,nsent,ndelivered,nread,ncost,tsent,tdelivered,tread };
  }

  
  return (
    <>
      <div className="content pb-0">
        <Row>
          <Col md="12">
            <Card className='mb-2'>
              <CardBody>
                <Row>
                
                  <Col md="3" sm='12'>
                    <p className="category">Select Model </p>
                  <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          name="singleSelect"
                          value={singleSelect}
                          onChange={(value) => {setsingleSelect(value)}}
                          options={
                            templates.map((item,index)=>{
                              return { value: item.templateid, label: item.templatename }
                            })
                            
                                
                               
                            
                             
                          }
                          placeholder="Select "
                        />
                    </Col>
                  <Col md="3" sm='12'>
                    <p className="category">Select Predictions </p>
                  <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          name="singleSelect"
                          value={singleSelect}
                          onChange={(value) => {setsingleSelect(value)}}
                          options={
                            templates.map((item,index)=>{
                              return { value: item.templateid, label: item.templatename }
                            })
                            
                                
                               
                            
                             
                          }
                          placeholder="Select "
                        />
                    </Col>
                  <Col md='3' sm='6'>
                  <Button 
                    color="primary "
                    className="mt-4 btn btn-icon animation-on-hover"
                    id="tooltipsubmit"
                    type="button"
                    onClick={()=>submitHandler()}
                  ><i className="tim-icons icon-double-right" /></Button>
                  <UncontrolledTooltip
                  delay={0}
                  placement="top"
                  target="tooltipsubmit"
                >
                  
                  Submit
                </UncontrolledTooltip>

                <Button className="btn-primary btn-simple btn-icon btn-round  btn-icon mt-4 pull-right" 
                    color="primary" 
                    data-placement="top"
                    id="tooltipexcel"
                    type="button"
                    onClick={()=>generatePdf()}
                  >
                    <i className="tim-icons icon-cloud-download-93" />
                  </Button>                  
                <UncontrolledTooltip
                  delay={0}
                  placement="top"
                  target="tooltipexcel"
                >
                  Excel
                </UncontrolledTooltip>
                  <Button className=" btn-primary  btn-simple btn-icon btn-round mt-4 pull-right" 
                  color="primary" 
                   data-placement="top"
                   id="tooltippdf"
                   type="button"
                   >
                    <i className="tim-icons icon-cloud-download-93" />
                  </Button>
                  <UncontrolledTooltip
                  delay={0}
                  placement="top"
                  target="tooltippdf"
                >
                  PDF
                </UncontrolledTooltip>
                  </Col>
                  {/* <Col md='2' sm='6' className='pull-right'>
                  
                  </Col>
                  <Col md='2' sm="12" className="mt-4">
                    <MDBInput label="Search" type="text" />
                  
                  </Col> */}
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col className="mb-0" md="12">
            <Card className="mb-0">
             
              <CardBody className="mb-0">
              <TableContainer component={Paper} className="scroll-height-350">
      <Table sx={{ minWidth: 650 }} aria-label="simple table" responsive striped>
        <thead>
          <tr>
                    <th >S no </th>
                    <th > Date</th>
                    <th >Name </th>
                    <th > i/p File</th>
                    <th > o/p File </th>
                               
          </tr>
         
        </thead>
        <tbody>
          {daywiseList?.length>0?daywiseList.map((row,index) => (
            
            <tr sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
               <td >{index+1}</td>
              <td >{row.DATE}</td>
              <td >{row.Sent}</td>
              <td >{row.Delivered}</td>
              <td >{row.Read}</td>
               {/*<td >{row.nsent}</td>
              <td >{row.ndelivered}</td>
              <td >{row.nread}</td>
              <td >{row.ncost}</td> */}
              
            </tr>
          )):<tr
        
          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
        >
          <td colSpan={5} >No Records</td></tr>
          }
        </tbody>
      </Table>
    </TableContainer>
              </CardBody>
              {/* <Row>
              <Col md="12" >
          <Pagination  className='pull-right'>
                    <PaginationItem>
                      <PaginationLink
                        aria-label="Previous"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        <span aria-hidden={true}>
                          <i
                            aria-hidden={true}
                            className="tim-icons icon-double-left"
                          />
                        </span>
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        1
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem className="active">
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        2
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        3
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        aria-label="Next"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        <span aria-hidden={true}>
                          <i
                            aria-hidden={true}
                            className="tim-icons icon-double-right"
                          />
                        </span>
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
          </Col>
              </Row> */}
            </Card>
          </Col>
         

        </Row>
       
      </div>
    </>
  )
}

export default TextReports;